import { GET_ORDER_REWARDS } from 'yoda-checkout-components/lib/actionTypes/RewardsActionTypes';

export const getOrderRewards = (payload) => ({
    type: GET_ORDER_REWARDS,
    payload,
});

export default { getOrderRewards };
